var hgk = hgk || {};
( function () {
    'use strict';
    jQuery( function () {
        hgk.init();
    } );

    hgk.init = function () {
        hgk.svg.init();
        hgk.nav.init();
        hgk.golfbox.init();
    };
    hgk.svg = {
        convert: function ( index, img, imgClass, imgURL, svgID ) {
            jQuery.get( imgURL, function ( data ) {
                var svg = jQuery( data ).find( 'svg' );
                if ( typeof imgClass !== undefined ) {
                    svg = svg.attr( 'class', imgClass );
                }
                svg = svg.removeAttr( 'xmlns:a' );
                hgk.svg.insert( index, img, svg );
            }, 'xml' );
        },
        insert: function ( index, img, svg ) {
            img.replaceWith( svg );
            setTimeout( function () {
                svg.addClass( 'svgo' ).attr( {
                    'width': '100%',
                    'height': '100%'
                } ).wrapAll('<div class="svgo-container"></div>');
            }, 100 + ( index * 10 ) );
        },
        init: function () {
            jQuery( 'img.svg' ).each( function ( index ) {
                var img = jQuery( this ),
                    imgClass = img.attr( 'class' ),
                    imgURL = img.attr( 'src' ),
                    svgID = /[^/]*$/.exec( imgURL )[ 0 ].replace( '.svg', '' );
                hgk.svg.convert( index, img, imgClass, imgURL, svgID );
            } );
        }
    };
    hgk.nav = {
        init: function () {
            jQuery( '.megamenu-hide' ).find( '.nav-link' ).click(function(event){
                window.open(jQuery(this).attr('href'),'_self')
            });
        }
    }
    hgk.golfbox = {
        init: function () {
            jQuery('.js-golfbox-login-form').find('input').blur();
        }
    }

}() );

